/**
 * Colors for an hour's values, so the eye finds a family at a glance: one
 * hue per Flow Optimizer category (traffic sky, conversions violet, money
 * amber, rates teal, advanced slate); profit and ROI read green above zero
 * and red below; a zero is dimmed — present, but nothing to look at.
 * For Media Devoted | Created By Ciro Autiero
 */
interface CategoryTone {
  /** The category's label pill. */
  pill: string;
  /** Its values. */
  value: string;
}

const TONES: Record<string, CategoryTone> = {
  traffic: { pill: 'bg-sky-500/10 text-sky-700 dark:text-sky-300', value: 'text-sky-700 dark:text-sky-300' },
  conversions: { pill: 'bg-violet-500/10 text-violet-700 dark:text-violet-300', value: 'text-violet-700 dark:text-violet-300' },
  financial: { pill: 'bg-amber-500/10 text-amber-700 dark:text-amber-300', value: 'text-amber-700 dark:text-amber-300' },
  rates: { pill: 'bg-teal-500/10 text-teal-700 dark:text-teal-300', value: 'text-teal-700 dark:text-teal-300' },
  advanced: { pill: 'bg-slate-500/10 text-slate-600 dark:text-slate-300', value: 'text-slate-600 dark:text-slate-300' },
};

const FALLBACK: CategoryTone = { pill: 'bg-muted text-muted-foreground', value: 'text-foreground' };

/** Metrics whose sign is the news: above zero earns, below zero loses. */
const SIGNED = new Set(['profit', 'roi']);

export const categoryTone = (category: string): CategoryTone => TONES[category] ?? FALLBACK;

/** The class of one value: dimmed at zero, green/red for profit and ROI, else its category's hue. */
export function valueTone(category: string, id: string, v: number): string {
  if (v === 0) return 'text-muted-foreground/60';
  if (SIGNED.has(id)) return v > 0 ? 'text-emerald-600 dark:text-emerald-400' : 'text-rose-600 dark:text-rose-400';
  return categoryTone(category).value;
}
